<template>
  <validation-observer ref="validator">
    <v-form class="mt-5" @submit.prevent="submit()">
      <v-container fluid class="mx-1060">
        <v-row>
          <v-col
            class="pr-md-7 pl-md-5"
            :lg="rightDrawer.opened ? 12 : 6"
            :md="rightDrawer.opened ? 12 : 12"
          >
            <ValidationProvider
              name="first_name"
              rules="required"
              v-slot="{ errors }"
            >
              <v-text-field
                name="first_name"
                :error-messages="errors"
                v-model="request.member.first_name"
                label="First Name"
                required
              />
            </ValidationProvider>
          </v-col>
          <v-col
            class="pr-md-7 pl-md-5"
            :lg="rightDrawer.opened ? 12 : 6"
            :md="rightDrawer.opened ? 12 : 12"
          >
            <ValidationProvider
              name="last_name"
              rules="required"
              v-slot="{ errors }"
            >
              <v-text-field
                name="last_name"
                :error-messages="errors"
                v-model="request.member.last_name"
                label="Last Name"
                required
              />
            </ValidationProvider>
          </v-col>
          <v-col
            class="pr-md-7 pl-md-5"
            :lg="rightDrawer.opened ? 12 : 6"
            :md="rightDrawer.opened ? 12 : 12"
          >
            <ValidationProvider
              name="email"
              rules="required|email"
              v-slot="{ errors }"
            >
              <v-text-field
                name="email"
                :error-messages="errors"
                v-model="request.member.email"
                label="Email"
                required
              />
            </ValidationProvider>
          </v-col>
          <v-col
            class="pr-md-7 pl-md-5"
            :lg="rightDrawer.opened ? 12 : 6"
            :md="rightDrawer.opened ? 12 : 12"
          >
            <CountryField
              name="country"
              rules="required"
              label="Country of Origin"
              item-value="alpha2Code"
              v-model="request.member.country_code"
            />
          </v-col>
          <v-col
            class="pr-md-7 pl-md-5"
            :lg="rightDrawer.opened ? 12 : 6"
            :md="rightDrawer.opened ? 12 : 12"
          >
            <ValidationProvider
              v-if="request.member.hasOwnProperty('years_of_diving')"
              name="diving_years"
              rules="integer"
              v-slot="{ errors }"
            >
              <v-text-field
                name="years_of_diving"
                :error-messages="errors"
                v-model="request.member.years_of_diving"
                label="Years of diving"
              />
            </ValidationProvider>
          </v-col>
          <v-col
            class="pr-md-7 pl-md-5"
            :lg="rightDrawer.opened ? 12 : 6"
            :md="rightDrawer.opened ? 12 : 12"
          >
            <ValidationProvider
              v-if="request.member.hasOwnProperty('no_of_dives')"
              name="diving_number"
              rules="integer"
              v-slot="{ errors }"
            >
              <v-text-field
                name="no_of_dives"
                :error-messages="errors"
                v-model="request.member.no_of_dives"
                label="Number of dives"
              />
            </ValidationProvider>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-card-actions class="flex-column flex-md-row">
      <v-btn
        large
        color="white"
        class="elevation-1 font-weight-bold mr-8"
        @click="cancel()"
        min-width="275px"
      >
        Cancel
      </v-btn>
      <v-btn
        large
        color="primary"
        class="elevation-1 font-weight-bold"
        @click.prevent="submit()"
        :disabled="request.submitting"
        min-width="275px"
      >
        Done
      </v-btn>
    </v-card-actions>
  </validation-observer>
</template>

<script>
import GroupRequest from '@request/GroupRequest';

export default {
  name: 'GroupMember',
  components: {
    CountryField: () => import('@components/utilities/CountryField'),
  },
  props: {
    member: {
      type: Object,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      request: new GroupRequest(this.$refs, {
        id: this.group.id,
        member: {
          ...new GroupRequest(this.$refs).data().member,
          ...this.member,
        },
      }),
    };
  },
  methods: {
    cancel(member) {
      this.$emit('done', member);
    },
    async submit() {
      if (await this.request.validate()) {
        let response = await this.request.addMember();
        if (response) {
          this.cancel(response.data);
          this.request.reset();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
